import { MARQUEE } from "../data/content";

export const Marquee = () => {
  const items = [...MARQUEE, ...MARQUEE];
  return (
    <div className="relative border-y border-[#2A201A] bg-surface/40 py-6 overflow-hidden" data-testid="marquee">
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {items.map((t, i) => (
          <span key={i} className="flex items-center font-display text-3xl sm:text-4xl font-light text-[#8F877C]">
            <span className="px-8">{t}</span>
            <span className="text-teal">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
